import { render, staticRenderFns } from "./ResourcesLibrary.vue?vue&type=template&id=c023b690&scoped=true"
import script from "./ResourcesLibrary.vue?vue&type=script&lang=js"
export * from "./ResourcesLibrary.vue?vue&type=script&lang=js"
import style0 from "./ResourcesLibrary.vue?vue&type=style&index=0&id=c023b690&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c023b690",
  null
  
)

export default component.exports